export default "__VITE_ASSET__a3b94174__"